export const styleConsts = {
    backgroundColor: {
        mainColor1: '#4b44b4',
        mainColor1DarkTheme: '#2d296c',
        mainColor1GreyTheme: '#4e4e4e',
        mainColor1SunnyTheme: '#4631ff',
        mainColor2: '#ccccff',
        mainColor2DarkTheme: '#4444aa',
        mainColor2GreyTheme: '#2b6d2b',
        mainColor2SunnyTheme: '#2b6d2b',
        openChatColor: '#b5c6f4',
        openChatColorDarkTheme: '#88bbdd',
        openChatColorGreyTheme: '#88bbdd',
        openChatColorSunnyTheme: '#88bbdd',
        popUpWindowBtnColor: '#2b6d2b',
        popUpWindowBtnColorDarkTheme: '#2b6d2b',
        popUpWindowBtnColorGreyTheme: '#888888',
        popUpWindowBtnColorSunnyTheme: '#2b6d2b',
    },
    color: {
        chatsListColor: '#444444',
        chatsListColorDarkTheme: '#dddddd',
        chatsListColorGreyTheme: '#dddddd',
        chatsListColorSunnyTheme: '#dddddd',
        favoriteIconColor: '#b79c00',
        favoriteIconColorDarkTheme: '#ffd700',
        favoriteIconColorGreyTheme: '#ffd700',
        favoriteIconColorSunnyTheme: '#ffd700',
        homeAppNameColor: '#4b44b4',
        homeAppNameColorDarkTheme: '#ffffff',
        homeAppNameColorGreyTheme: '#ffffff',
        homeAppNameColorSunnyTheme: '#ffffff',
    },
};
